import validationMessages from '../../app/i18n/validationMessages'
import { intl } from '../../utils/translations'
import Yup from '../../utils/yup'

const schema = Yup.object().shape({
  password: Yup.string().ensure().required(intl?.formatMessage(validationMessages.schemaFieldRequired)).trim(),
})

export default schema
